module.exports = __webpack_public_path__ + "img/pro_six_1.7bca5cfa.jpg";